module.exports = __webpack_public_path__ + "img/fernando.cordova.canela.ddff1bc0.jpg";